/**
 * Section type → header icon, aligned with the section-tab nav rail.
 *
 * Its own module so `DropSectionRenderer` is dispatch and nothing else — the
 * map plus its fourteen icon imports were a third of that file's head, and the
 * nav rail imports the map without wanting the renderer.
 */
import React from "react";
import {
    FaGamepad,
    FaBullseye,
    FaTrophy,
    FaUsers,
    FaShoppingCart,
    FaVideo,
    FaInfoCircle,
    FaPuzzlePiece,
    FaChartLine,
    FaMedal,
    FaBolt,
    FaGift,
    FaNewspaper,
} from "react-icons/fa";
import {MdLeaderboard} from "react-icons/md";
import type {SurfaceSectionType} from "@/hooks/hub/useGetHub";

export const SECTION_ICONS: Record<SurfaceSectionType, React.ReactNode> = {
    GAMES: <FaGamepad />,
    MISSIONS: <FaBullseye />,
    TOURNAMENTS: <FaTrophy />,
    LEAGUES: <FaMedal />,
    LADDERS: <FaChartLine />,
    LEADERBOARDS: <MdLeaderboard />,
    GUILDS: <FaUsers />,
    CHALLENGES: <FaBolt />,
    CAMPAIGNS: <FaShoppingCart />,
    EXCLUSIVES: <FaGift />,
    STREAMING: <FaVideo />,
    INFO: <FaInfoCircle />,
    CUSTOM: <FaPuzzlePiece />,
    NEWS: <FaNewspaper />,
    ENGAGEMENT: <FaBolt />,
    /* Reuses the roster icon — this IS the roster, seen from the other side. */
    OFFICIAL_FOR: <FaUsers />,
};

